<script setup lang="ts">
defineProps<{ html: string }>();
</script>

<template>
  <div class="le-ng-article-info-box" v-html="html"></div>
</template>

<style scoped lang="less">
@import "@dsk/styles/all.less";

.le-ng-article-info-box {
  padding: 11px 27px;
  border-radius: 4px;
  background: @colors[@primary][100];
  box-shadow: @shadows[floating-default];
  .body-text("m");
  color: @colors[@neutrals][300];

  // Reset style of old article info boxes
  ::v-deep(.article-prefix),
  ::v-deep(.article-separator-box),
  ::v-deep(.notice-box) {
    margin: 0 !important;
    padding: 0 !important;
    border: none;
    background-color: initial;
    text-align: left !important;

    p {
      margin: 0 !important;
    }
  }

  // Revert styles that have been reset due to being within the le- prefix
  ::v-deep(.loose-conjugations) {
    h3 {
      margin-top: 12px;
      font-family: Merriweather, serif;
      font-size: 20px;
    }
  }
}
</style>
